const API_KEY = "1f46f8d5a63f46a193a440488ac905c8";

module.exports = API_KEY;
